<div class="mb-4" *ngIf="loadingCompleted">
  <app-basic-card>
    <div class="d-flex justify-content-start align-items-center mb-2">
      <h4 class="m-0">{{ operationTitle }}</h4>
    </div>
    <mat-stepper #isvStepper [linear]="true" [(selectedIndex)]="selectedIndex">
      <!-- Step di selezione del soggetto richiedente l'operazione -->
      <ng-container *ngIf="ndgVariationForm">
        <mat-step [stepControl]="ndgVariationForm.valid">
          <ng-template matStepLabel
            >Selezione del soggetto richiedente</ng-template
          >
          <ng-template matStepContent>
            <div class="step-item-box">
              <app-ndg-variation
                [form]="ndgVariationForm"
                [ndgVariationList]="ndgVariationList"
                [selectedSubject]="searchedTutor"
                (onSubjectSelection)="onTutorSelection($event)"
              ></app-ndg-variation>
            </div>
            <div class="d-flex justify-content-end">
              <button
                mat-raised-button
                color="primary"
                (click)="goToNextStep('NDG_VARIATION_STEP')"
                [disabled]="
                  (!ndgVariationForm.valid && !ndgVariationForm.disabled) || !tutorHasValidDocument
                "
              >
                Avanti
              </button>
            </div>
          </ng-template>
        </mat-step>
      </ng-container>
      <!-- Step di inserimento dell'operazione -->
      <ng-container *ngIf="isSingleStepOperation; else multiStepOperationBlock">
        <mat-step>
          <ng-template matStepLabel>Inserimento operazione</ng-template>
          <ng-template matStepContent>
            <div class="step-item-box">
              <ng-container [ngSwitch]="operationId">
                <!-- Annullo operazione -->
                <ng-container *ngSwitchCase="'_ANAPP'">
                  <app-cancel-operation> </app-cancel-operation>
                </ng-container>
                <!-- Versamento Aggiuntivo -->
                <ng-container *ngSwitchCase="'_VAGG'">
                  <app-additional-payment-isv
                    [form]="firstStepForm"
                    [ibanList]="ibansList"
                    [assets]="isPrevidentialPolicy ? policyAssets : activeFunds"
                    [debitDate]="effectDate"
                    [lines]="lines"
                    [isReadOnly]="isWriteDisabled"
                    (arePresetsValid)="onPresetsValidChange($event)"
                  ></app-additional-payment-isv>
                </ng-container>
                <!-- Sospensione Pagamento Premi -->
                <ng-container *ngSwitchCase="'_INPAG'">
                  <app-premium-payment-suspension
                    [form]="firstStepForm"
                  ></app-premium-payment-suspension>
                </ng-container>
                <!-- Riattivazione Pagamento Premi -->
                <ng-container *ngSwitchCase="'_RIAPU'">
                  <app-premium-payment-reactivation
                  [form]="firstStepForm"
                  ></app-premium-payment-reactivation>
                </ng-container>
                <!-- Variazione Premio Frazionamento -->
                <ng-container *ngSwitchCase="'_VPRFR'">
                  <app-frequency-premium-change
                  [form]="firstStepForm"
                  [frequenciesList]="frequenciesList"
                  [variationOptionsForm]="additionalForm"
                  [currentFrequency]="currentFrequency"
                  [currentInstallmentAmount]="currentInstallmentAmount"
                  >
                  </app-frequency-premium-change>
                </ng-container>
                <!-- Riscatto totale -->
                <ng-container *ngSwitchCase="'_RISTO'">
                  <app-total-redeem
                    [form]="firstStepForm"
                    [ibanList]="ibansList"
                  ></app-total-redeem>
                </ng-container>
                <!-- Riscatto parziale -->
                <ng-container *ngSwitchCase="'_RISPA'">
                  <app-partial-redeem-isv
                    [form]="firstStepForm"
                    [ibanList]="ibansList"
                    [isReadOnly]="isWriteDisabled"
                    [assets]="activeFunds"
                    [redemptionTypes]="redemptionTypes"
                    (emitSelectedRedemptionType)="onSelectedRedemptionType($event)"
                  ></app-partial-redeem-isv>
                </ng-container>
                <!-- Aggiornamento documento di identita -->
                <ng-container *ngSwitchCase="'INT_002'">
                  <app-document-change
                    [form]="firstStepForm"
                    [documentTypeList]="documentTypesList"
                    [documentReleaseAuthorityList]="documentReleaseAuthoritesList"
                    [previousDocuments]="previousDocuments"
                    [isReadOnly]="isWriteDisabled"
                    [isPolicyPrevidenziale]="isPolicyPrevidenziale"
                    [tableValues]="tableValues"
                  ></app-document-change>
                </ng-container>
                <!-- Variazione filiale -->
                <ng-container *ngSwitchCase="'INT_001'">
                  <app-branch-office-variation
                    [form]="firstStepForm"
                    [currentBranchOffice]="currentBranchOffice"
                  ></app-branch-office-variation>
                </ng-container>
                <!-- Variazione residenza -->
                <ng-container *ngSwitchCase="'69'">
                  <app-residence-change-isv
                    [form]="firstStepForm"
                    [additionalForm]="additionalForm"
                    [countriesList]="countriesList"
                    [provincesList]="provincesList"
                    [placesList]="placesList"
                    [figureAnagrafiche]="figureAnagrafiche"
                        [registryTypeOperation]="'Postale'"
                  ></app-residence-change-isv>
                </ng-container>
                <!-- Variazione recapito -->
                <ng-container *ngSwitchCase="'_VRECP'">
                  <app-residence-change-isv
                    [form]="firstStepForm"
                    [additionalForm]="additionalForm"
                    [countriesList]="countriesList"
                    [provincesList]="provincesList"
                    [placesList]="placesList"
                  ></app-residence-change-isv>
                </ng-container>
                <!-- Variazione pagatore -->
                <ng-container *ngSwitchCase="'INT_004'">
                  <app-payer-variation [payersList]="payersList" [comuniList]="comuniList" [countriesList]="countriesList"
                  [provinceList]="provincesList" [documentTypeList]="documentTypesList"
                  [documentReleaseAuthorityList]="documentReleaseAuthoritesList" (onPayerUpdate)="onPayerUpdate($event)" >
                  </app-payer-variation>
                </ng-container>
                <!-- Rettifica anagrafica -->
                <ng-container *ngSwitchCase="'INT_003'">
                  <app-registry-adjustment
                    [form]="firstStepForm"
                    [countriesList]="countriesList"
                    [provincesList]="provincesList"
                  ></app-registry-adjustment>
                </ng-container>
                <!-- Comunicazione sinistro -->
                <ng-container *ngSwitchCase="'_SIMOR'">
                  <app-claim-notification-isv
                    [form]="firstStepForm"
                    [additionalForm]="additionalForm"
                  ></app-claim-notification-isv>
                  </ng-container>
                <ng-container *ngSwitchCase="'INT_005'">
                  <app-debit-date-variation
                    [form]="firstStepForm"
                    [currentDebitDate]="debitDate"
                  ></app-debit-date-variation>
                </ng-container>
                <!-- Liquidazione a scadenza -->
                <ng-container *ngSwitchCase="'10'">
                  <app-liquidation-maturity
                    [form]="firstStepForm"
                    [ibanList]="ibansList"
                  ></app-liquidation-maturity>
                </ng-container>
                <!-- Cessione contraenza -->
                  <ng-container *ngSwitchCase="'_VCONT'">
                    <app-contractor-change-isv
                      [searchForm]="firstStepForm"
                      [legalGuardianForm]="additionalForm"
                      [isReadOnly]="isWriteDisabled"
                      [searchedSubject]="newContractorData"
                      [searchCompleted]="newContractorSearched"
                      [searchedLegalGuardian]="searchedLegalGuardian"
                      (onContractorSearch)="onContractorSearch($event)"
                      (onContractorReset)="onContractorReset()"
                      (onLegalGuardianSearch)="onLegalGuardianSearch($event)"
                    ></app-contractor-change-isv>
                  </ng-container>
                <!-- Variazione data pensionamento -->
                <ng-container *ngSwitchCase="'INT_006'">
                  <app-retirement-date-variation
                    [form]="firstStepForm"
                    [currentRetirementDate]="retirementDate"
                  ></app-retirement-date-variation>
                </ng-container>
                <!-- Variazione Linea Investimento -->
                <ng-container *ngSwitchCase="'_SWITC'">
                    <ng-container *ngIf="!isPrevidentialPolicy">
                        <app-change-investment-line-isv
                            [form]="firstStepForm"
                            [assets]="lines"
                            [operationCost]="operationCost"
                            [operationEffectDate]="operationEffectDate">
                        </app-change-investment-line-isv>
                    </ng-container>
                    <ng-container *ngIf="isPrevidentialPolicy">
                        <app-change-investment-line-isp
                            [form]="firstStepForm"
                            [assets]="lines">
                        </app-change-investment-line-isp>
                    </ng-container>
                </ng-container>
                <!-- Ribilanciamento -->
                <ng-container *ngSwitchCase="'VU'">
                  <app-rebalance-investments [rebalancedLine]="rebalancedLine" [operationCost]="operationCost" [operationEffectDate]="operationEffectDate">
                  </app-rebalance-investments>
                </ng-container>
                <!-- Reindirizzamento Fondi -->
                <ng-container *ngSwitchCase="'INT_008'">
                  <app-redirect-funds
                    [currentFunds]="activeFunds"
                    [policyFunds]="investmentFunds"
                    [form]="firstStepForm"
                    [isReadOnly]="isWriteDisabled">
                  </app-redirect-funds>
                </ng-container>

                <!-- Variazione C/C uni20 -->
                <ng-container *ngSwitchCase="'_VCBMU'">
                  <ng-container *ngIf="isPrevidentialPolicy; else vcbmu_uni20">
                    <app-bank-account-update [form]="firstStepForm" [ibanList]="ibansList"
                      [currentBankAccount]="currentBankAccount">
                    </app-bank-account-update>
                  </ng-container>
                  <ng-template #vcbmu_uni20>
                    <app-bank-account-change-isv
                      [form]="firstStepForm"
                      [isReadOnly]="isWriteDisabled"
                      [ibanList]="ibansList"
                      [currentBankAccount]="currentBankAccount"
                    >
                    </app-bank-account-change-isv>
                  </ng-template>
                </ng-container>
                <!-- Variaizone Beneficiari -->
                <!-- Spostamento Iscritto (Cambio Datore TFR) -->
                <ng-container *ngSwitchCase="'INT_010'">
                  <app-spostamento-iscritto
                    [currentEmployerData]="currentEmployersData"
                    (modifiedData)="onModifiedOrAddedEmployer($event)"
                  ></app-spostamento-iscritto>
                </ng-container>
                <!-- Variaizone Beneficiari -->
                <ng-container *ngSwitchCase="'_VBENE'">
                  <!-- Variazione beneficiario-->
                  <app-beneficiary-change-isp
                    ng-container
                    *ngIf="isPrevidentialPolicy; else v_bene_uni20"
                    [holderBeneficiaryRelationshipList]="
                      holderBeneficiaryRelationshipList
                    "
                    [beneficiariesTypes]="previdentialBeneficiariesTypes"
                    [comuniList]="comuniList"
                    [countriesList]="countriesList"
                    [provinceList]="provincesList"
                    (emitBeneficiariesList)="
                      onBeneficiariesUpdatePrevidential($event)
                    "
                    [currentBeneficiaries]="
                      previdentialBeneficiariesList
                    "
                    [beneficiariesList]="previdentialBeneficiariesList"
                    [form]="firstStepForm"
                  ></app-beneficiary-change-isp>
                  <ng-template #v_bene_uni20>
                    <app-beneficiary-change-isv
                      [beneficiariesList]="beneficiariesList"
                      [thirdPartyContact]="thirdParty"
                      [countriesList]="countriesList"
                      [provincesList]="provincesList"
                      [holderBeneficiaryRelationshipList]="
                        holderBeneficiaryRelationshipList
                      "
                      [insuredBeneficiaryRelationshipList]="
                        insuredBeneficiaryRelationshipList
                      "
                      [beneficiaryDeathTipologies]="beneficiaryDeathTipologies"
                      [beneficiaryLifeTipologies]="beneficiaryLifeTipologies"
                      [isReadOnly]="isWriteDisabled"
                      (emitBeneficiariesList)="onBeneficiariesUpdate($event)"
                      (emitThirdPartyContact)="onThirdPartyUpdate($event)"
                    ></app-beneficiary-change-isv>
                  </ng-template>
                </ng-container>
              </ng-container>
            </div>
            <div
              class="d-flex mt-4"
              [ngClass]="
                showPreviousButton('OPERATION_STEP')
                  ? 'justify-content-between'
                  : 'justify-content-end'
              "
            >
              <button
                *ngIf="showPreviousButton('OPERATION_STEP')"
                mat-raised-button
                color="accent"
                (click)="previous()"
              >
                Indietro
              </button>
              <button
                mat-raised-button
                color="primary"
                [disabled]="!isStepValid('OPERATION_STEP')"
                (click)="goToNextStep('OPERATION_STEP')"
              >
                Avanti
              </button>
            </div>
          </ng-template>
        </mat-step>
      </ng-container>
      <ng-template #multiStepOperationBlock>
        <ng-container [ngSwitch]="operationId">
          <ng-container *ngSwitchCase="'_SWITR'">
            <mat-step>
              <ng-template matStepLabel>Disinvestimento</ng-template>
              <ng-template matStepContent>
                <div class="step-item-box">
                  <app-branch-switch-divestment-intesa
                    [form]="firstStepForm"
                    [policyFunds]="activeFunds"
                    [isReadOnly]="isWriteDisabled"
                    (emitFunds)="emittedFunds($event)"
                  ></app-branch-switch-divestment-intesa>
                </div>
                <div class="d-flex justify-content-end">
                  <button
                    mat-raised-button
                    color="primary"
                    (click)="goToNextStep('DISINVESTMENT_STEP')"
                    [disabled]="!isStepValid('DISINVESTMENT_STEP')"
                  >
                    Avanti
                  </button>
                </div>
              </ng-template>
            </mat-step>
            <mat-step>
              <ng-template matStepLabel>Investimento</ng-template>
              <ng-template matStepContent>
                <div class="step-item-box">
                  <app-branch-switch-investment-intesa
                    [assets]="investmentFunds"
                    [policyFunds]="activeFunds"
                    [form]="additionalForm"
                    [isReadOnly]="isWriteDisabled"
                  ></app-branch-switch-investment-intesa>
                </div>
                <div class="d-flex justify-content-between">
                  <button
                    mat-raised-button
                    color="accent"
                    (click)="previous('INVESTMENT_STEP')"
                  >
                    Indietro
                  </button>
                  <button
                    mat-raised-button
                    color="primary"
                    (click)="goToNextStep('OPERATION_STEP')"
                    [disabled]="!isStepValid('INVESTMENT_STEP')"
                  >
                    Avanti
                  </button>
                </div>
              </ng-template>
            </mat-step>
          </ng-container>
        </ng-container>
      </ng-template>
      <!-- Step di recap per anagrafica contraente e eventuale tutor -->
      <ng-container>
        <mat-step *ngIf="hasQuestionnaireStep">
          <ng-template matStepLabel>Riepilogo dati</ng-template>
          <ng-template matStepContent>
            <div class="step-item-box">
              <app-registry-recap
                [contractorRegistryForm]="contractorRegistryForm"
                [contractorResidenceForm]="contractorResidenceForm"
                [contractorAddressForm]="contractorAddressForm"
                [contractorIdentificationDocumentForm]="contractorIdentificationDocumentForm"
                [contractorBusinessForm]="contractorBusinessForm"
                [properVerificationForm]="newContractorProperVerificationForm"
                [consentsForm]="newContractorConsentsForm"
                [legalGuardianRegistryForm]="legalGuardianRegistryForm"
                [legalGuardianResidenceForm]="legalGuardianResidenceForm"
                [legalGuardianAddressForm]="legalGuardianAddressForm"
                [legalGuardianIdentificationDocumentForm]="legalGuardianIdentificationDocumentForm"
                [legalGuardianProperVerificationForm]="legalGuardianProperVerificationForm"
                [insuredForm]="insuredForm"
                [beneficiaryForm]="beneficiaryForm"
                [operationForm]="operationDataForm"
                [operatorForm]="operatorDataForm"
                [effectiveOwnersList]="effectiveOwnersList"
                [saeList]="saeList"
                [taeList]="taeList"
                [atecoList]="atecoList"
                [relazioneContraenteBeneficiario]="relazioneContraenteBeneficiario"
                [relazioneContraenteAssicurato]="relazioneContraenteAssicurato"
                [relazioneContraenteEsecutore]="relazioneContraenteEsecutore"
                [tipoDelega]="tipoDelega"
                [activityTypes]="activityTypes"
                [beneficiariesClassification]="beneficiariesClassification"
                [businessTypes]="businessTypes"
                [agreementPurposeList]="agreementPurposeList"
                [countriesList]="countriesList"
                [provincesList]="provincesList"
                [placesList]="placesList"
                [documentTypeList]="documentTypesList"
                [documentReleaseAuthorityList]="documentReleaseAuthoritesList"
                [agreementPurposeList]="agreementPurposeList"
                [customerBehaviourList]="customerBehaviourList"
                [documentationList]="documentationList"
                [fundsOriginList]="fundsOriginList"
                [incomeLevelsList]="incomeLevelsList"
                [executionModeList]="executionModeList"
                [operationExecutionModeList]="operationExecutionModeList"
                [presenceInExternalList]="presenceInExternalList"
                [professionsList]="professionsList"
                [incomeBracketsList]="incomeBracketsList"
                [productCategoriesList]="productCategoriesList"
                [riscattoTypesList]="riscattoTypesList"
                [versamentoTypesList]="versamentoTypesList"
                [holderBeneficiaryRelationshipList]="holderBeneficiaryRelationshipList"
                [insuredBeneficiaryRelationshipList]="insuredBeneficiaryRelationshipList"
                [chargeTypes]="chargeTypes"
                [operationPurposeList]="operationPurposeList"
                [isReadOnly]="isWriteDisabled"
              ></app-registry-recap>
            </div>
            <div class="d-flex mt-4 justify-content-between">
              <button mat-raised-button color="accent" (click)="previous()">
                Indietro
              </button>
              <button
                mat-raised-button
                color="primary"
                [disabled]="!isStepValid('REGISTRY_RECAP_STEP')"
                (click)="goToNextStep('REGISTRY_RECAP_STEP')"
              >
                Avanti
              </button>
            </div>
          </ng-template>
        </mat-step>
      </ng-container>
      <mat-step>
        <ng-template matStepLabel>Download documentazione</ng-template>
        <ng-template matStepContent>
          <app-document-download
            [documents]="documentsList"
            [isAlreadySubmitted]="isAlreadySubmitted"
          ></app-document-download>
          <div class="d-flex justify-content-between mt-4">
            <button
              mat-raised-button
              color="accent"
              [disabled]="isCancelOperation"
              (click)="previous()"
            >
              Indietro
            </button>
            <button
              mat-raised-button
              color="primary"
              [disabled]="hasDocsToDownload"
              (click)="goToNextStep()"
            >
              Avanti
            </button>
          </div>
        </ng-template>
      </mat-step>
      <mat-step>
        <ng-template matStepLabel>Caricamento documentazione</ng-template>
        <ng-template matStepContent>
          <app-document-upload
            [documents]="documentsList"
            [isAlreadySubmitted]="isAlreadySubmitted"
            [isHelpDeskAccount]="cannotOperate"
          ></app-document-upload>
          <div class="d-flex justify-content-between mt-4">
            <button mat-raised-button color="accent" (click)="previous()">
              Indietro
            </button>
            <button
              mat-raised-button
              color="primary"
              [disabled]="hasDocsToUpload"
              *ngIf="!isAlreadySubmitted && !cannotOperate"
              (click)="finalizeOperation()"
            >
              Conferma
            </button>
          </div>
        </ng-template>
      </mat-step>
    </mat-stepper>
  </app-basic-card>
</div>
